import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { fetchReceiptByEnrollId } from "services/receiptService";
import { generateReceiptPdf } from "utils/receiptPdfGenerator";

/**
 * Receipt download control — visible only for approved + paid enrollments.
 * @param {{ enrollId: string, disabled?: boolean, className?: string }} props
 */
const ReceiptDownloadButton = ({ enrollId, disabled = false, className = "" }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = useCallback(async () => {
    if (loading || !enrollId) {
      return;
    }

    setLoading(true);
    try {
      const receipt = await fetchReceiptByEnrollId(enrollId);
      if (!receipt) {
        toast.error("Receipt data is not available.");
        return;
      }
      await generateReceiptPdf(receipt);
      toast.success("Receipt downloaded successfully.");
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to download receipt. Please try again.";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  }, [enrollId, loading]);

  return (
    <button
      type="button"
      className={`btn btn-outline-primary btn-sm me-2 ${className}`}
      onClick={handleDownload}
      disabled={disabled || loading}
      title="Download Receipt"
      aria-label="Download Receipt"
    >
      {loading ? (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
      ) : (
        <FontAwesomeIcon icon={faReceipt} />
      )}
    </button>
  );
};

export default ReceiptDownloadButton;
